import type { FileIconProps } from './FileIcon';

const FileFodFinIcon = ({ extension, color, size = 28, ...props }: FileIconProps) => (
  <svg width={size} height={size * 1.25} viewBox='0 0 28 35' fill={color} {...props}>
    <g clipPath='url(#prefix__clip0)'>
      <path
        d='M4 35.5h20a4 4 0 0 0 4-4v-21L18 .5H4a4 4 0 0 0-4 4v27a4 4 0 0 0 4 4Z'
        fill='#50B2C2'
      />
      <path opacity={0.4} d='M18 10.5V.5l10 10H18Z' fill='#fff' />
      <g opacity={0.5}>
        <path d='M-4 13v3h23v-3L7.5 8.5-4 13Z' fill='url(#b)' />
        <path d='M17.467 28V17.5h-4.6V28h4.6Z' fill='url(#c)' />
        <path d='M9.8 17.5V28H5.2V17.5h4.6Z' fill='url(#d)' />
        <path d='M2.133 28V17.5h-4.6V28h4.6Z' fill='url(#e)' />
        <path d='M19 32.5v-3H-4v3h23Z' fill='url(#f)' />
      </g>
      <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
        {extension?.toUpperCase()}
      </text>
    </g>
    <defs>
      <linearGradient
        id='prefix__paint0_linear'
        x1={11}
        y1={14}
        x2={11}
        y2={34.5}
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient id='b' x1={7.5} y1={8.5} x2={7.5} y2={32.5} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient id='c' x1={7.5} y1={8.5} x2={7.5} y2={32.5} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient id='d' x1={7.5} y1={8.5} x2={7.5} y2={32.5} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient id='e' x1={7.5} y1={8.5} x2={7.5} y2={32.5} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient id='f' x1={7.5} y1={8.5} x2={7.5} y2={32.5} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <clipPath id='prefix__clip0'>
        <path d='M0 4a4 4 0 014-4h20a4 4 0 014 4v27a4 4 0 01-4 4H4a4 4 0 01-4-4V4z' fill='#fff' />
      </clipPath>
    </defs>
  </svg>
);

export default FileFodFinIcon;
